"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STANDING_ORDER = void 0;
var STANDING_ORDER = {
  TEXT__SUPPLIER_NAME: 'standingOrder-span-supplierName',
  BUTTON__SUPPLIER_INFO: 'standingOrder-button-supplierInfo',
  TEXT__CREATED_DATE: 'standingOrder-span-createdDate',
  TEXT__INTERVAL: 'standingOrder-span-interval',
  TEXT__NEXT_DATE: 'standingOrder-span-nextDate',
  REORDER_MODAL: {
    TEXT__WARNING: 'standingOrderReorderModal-p-warning',
    BUTTON__CANCEL: 'standingOrderReorderModal-button-cancel',
    BUTTON__ADD_TO_CART: 'standingOrderReorderModal-button-addToCart'
  },
  EDIT_INTERVAL_MODAL: {
    INPUT__INTERVAL: 'standingOrderEditIntervalModal-input-interval',
    BUTTON__CANCEL: 'standingOrderEditIntervalModal-button-cancel',
    BUTTON__SAVE: 'standingOrderEditIntervalModal-button-save'
  },
  STOP_ORDER_MODAL: {
    BUTTON__CANCEL: 'standingOrderStopOrderModal-button-cancel',
    BUTTON__STOP: 'standingOrderStopOrderModal-button-stopOrder'
  }
};
exports.STANDING_ORDER = STANDING_ORDER;